var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AlertDismiss',{ref:"alertDismiss"}),_c('b-pagination',{staticClass:"m-2",attrs:{"total-rows":_vm.rows,"per-page":_vm.filter.pageSize,"aria-controls":"table-list-conflict","pills":""},model:{value:(_vm.filter.page),callback:function ($$v) {_vm.$set(_vm.filter, "page", $$v)},expression:"filter.page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }